import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const WebinarSchedule = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
    // Listen for iframe height messages
    const handleMessage = (e) => {
      if (e.data && e.data.iframe === "webinar-event") {
        const iframe = document.getElementById("webinar-iframe-ev-c0a0ff89");
        if (iframe) iframe.style.height = (e.data.height + 5) + "px";
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-darkerBlue to-darkBlue text-white">
      <div className="container max-w-4xl mx-auto px-4">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Jadwal <span className="text-primary">Webinar</span>
          </h2>
          <p className="text-lg md:text-xl text-textGray">
            Pilih sesi yang sesuai dengan jadwal Anda
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-gradient-to-br from-darkGray/50 to-darkGray/30 rounded-2xl p-8 backdrop-blur-sm border border-primary/20 shadow-2xl"
        >
          <iframe 
            src="https://jadwal.gampangin.ai/event.php?slug=ev-c0a0ff89" 
            style={{ width: '100%', border: 'none', overflow: 'hidden', lineHeight: '1.2' }}
            scrolling="no" 
            id="webinar-iframe-ev-c0a0ff89"
            title="Jadwal Webinar News Hack"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="text-center mt-8"
        >
          <p className="text-lg text-primary font-semibold mb-2">
            🎯 GRATIS RE-SEAT!
          </p>
          <p className="text-base text-textGray">
            Tidak bisa hadir? Tenang, Anda bisa ikuti ulang webinar di batch berikutnya tanpa biaya tambahan
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default WebinarSchedule;